import PropType from 'prop-types';
import LocalizedMessageDynamic from './LocalizedMessageDynamic';
import useProcessChunkFromFixedTokens from './useProcessChunkFromFixedTokens';

const propTypes = {
    /**
     * Message template that contains tokens.
     * Example: "Hello {0}, good {1}"
     */
    template: PropType.string.isRequired,
    /**
     * Tokens to embed into the template. The order to maps to the token numbers: {0}, {1}, etc.
     */
    tokens: PropType.arrayOf(PropType.node).isRequired,
};

/**
 * A React component that replaces i18n tokens with elements within a message string.
 */
const LocalizedMessage = ({ template, tokens }) => {
    const processChunk = useProcessChunkFromFixedTokens(tokens);
    return <LocalizedMessageDynamic processChunk={processChunk} template={template} />;
};

LocalizedMessage.propTypes = propTypes;

export default LocalizedMessage;
